var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"printerListHeader"},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }